import { render, staticRenderFns } from "./CompSequentialList.vue?vue&type=template&id=133deded&scoped=true&"
import script from "./CompSequentialList.vue?vue&type=script&lang=ts&"
export * from "./CompSequentialList.vue?vue&type=script&lang=ts&"
import style0 from "./CompSequentialList.vue?vue&type=style&index=0&id=133deded&prod&scoped=true&lang=css&"
import style1 from "./CompSequentialList.vue?vue&type=style&index=1&id=133deded&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "133deded",
  null
  
)

export default component.exports